import { datadogRum } from "@datadog/browser-rum";
import { setOperatingHoursFromPartnerDetails } from "./operatingHoursUtil";

type Destination = any;

type TowInfo = {
  distanceFromCurrentLocation: number;
  distanceUnits: 'mile' | 'kilometer';
  unitsShorthand: 'mi' | 'km';
  overMileageDistance: string;
  overMileageCost: string;
  totalTowCost: string;
};

type PartnerDestinationDetails = Destination & {
  bizName?: string;
  dealerId?: string;
  isSecureFacility?: boolean;
  towInfo?: TowInfo;
  operatingHours?: unknown;
};

export const getMapTowInfoToDestination = (
  destination: Destination
): PartnerDestinationDetails | null => {
  try {
    // Already processed
    if (destination?.towInfo?.distanceFromCurrentLocation) {
      return destination as PartnerDestinationDetails;
    }

    if (!destination?.reference) {
      return;
    }

    const distanceUnits: TowInfo['distanceUnits'] = 'mile';

    const unitsShorthand: TowInfo['unitsShorthand'] = 'mi';


    const distanceFromCurrentLocation = destination.totalMiles ?? 0;

    const partnerDestinationDetails: PartnerDestinationDetails = {
      ...destination,
      bizName: destination.name,
      dealerId: destination.reference,
      isSecureFacility: destination.isSecureFacility === true || destination.isSecureFacility === "true",
      towInfo: {
        distanceFromCurrentLocation,
        distanceUnits,
        unitsShorthand,
        overMileageDistance: "0.00",
        overMileageCost: "0.0",
        totalTowCost: "0.00",
      },
    };

    partnerDestinationDetails.operatingHours = setOperatingHoursFromPartnerDetails(partnerDestinationDetails);

    return partnerDestinationDetails;
  } catch (error) {
    datadogRum.addError(
      new Error(
        `Error in getMapTowInfoToDestination ${destination?.name}: ${String(error)}`
      )
    );
    return null;
  }
}